<template>
    <div class="container-fluid" >
        <headerApp :title="this.translate('profileTitle')"></headerApp>
        <div class="row">
            <div class="col-xs-24">
                <div class="col-container">
                    <div id='form' class='form row'>
                        <h1 v-lang.myProfile>Mi perfil</h1>
                        <div class='profile_image-container' v-if="settings.modulo_mostrar_foto_perfil_chofer && isChofer || settings.modulo_foto_pasajero">
                            <div class="profile-pic" @click="changePhoto" v-imgSrc="profilePic"
                                :class="{'loading': loadingImg}">
                                <button @click="changePhoto" class="profile_image-edit" :disabled="loadingImg">
                                    <svg-item :size="24" :icon="'editar'"></svg-item>
                                </button>
                                <upload-file :name="'profile'" @change="onPhotoChange" ref="file"></upload-file>
                            </div>
                        </div>
                        <div id="user_profile">
                            <div class="form-input-wrapper"  v-if="!isChofer">
                                <label class="form-label" for="profile_txt_name" v-lang.name>Nombre</label>
                                <input v-jump:focus="'profile_txt_surename'" ref="profile_txt_name" class="form-input" maxlength="25" type="text" id="profile_txt_name" v-model='name' :class="{'has-error': nombreError.state }"/>
                                <span class="error" v-if="nombreError.state"> {{nombreError.message}} </span>
                            </div>
                            <div class="form-input-wrapper" v-if="!isChofer">
                                <label class="form-label" for="profile_txt_surename" v-lang.sureName>Apellido</label>
                                <input v-jump:focus="'profile_select_zone'" class="form-input" ref="profile_txt_surename" maxlength="25" type="text" id="profile_txt_surename" v-model='sureName' :class="{'has-error': apellidoError.state }"/>
                                <span class="error" v-if="apellidoError.state"> {{apellidoError.message}} </span>
                            </div>

                            <div class="form-input-wrapper" v-if="isChofer || settings.solicitar_telefono_pasajeros">
                                <label class="form-label" for="profile_txt_phone">{{ settings.solicitar_telefono_pasajeros && settings.solicitar_telefono_pasajeros.label ? $translateFromText(settings.solicitar_telefono_pasajeros.label) : translate('telefono') }}</label>
                                <input v-jump:focus="'profile_change_password'" class="form-input" ref="profile_txt_phone" maxlength="25" type="text" id="profile_txt_phone" v-model="telefono" :class="{'has-error': apellidoError.state }"/>
                                <span class="error" v-if="telefonoError.state"> {{telefonoError.message}} </span>
                                <span class="help" v-if="settings.solicitar_telefono_pasajeros && settings.solicitar_telefono_pasajeros.help"> {{ $translateFromText(settings.solicitar_telefono_pasajeros.help) }} </span>
                            </div>
                            <div class="form-input-wrapper" v-if="zonas.length > 1 && !isChofer" >
                                <label for="profile_select_zone" class="form-label" v-lang.zonas>Zona</label>
                                <select v-jump:focus="'profile_change_password'" id="profile_select_zone" ref="profile_select_zone" class="form-select" v-model="selectedZone" :class="{'form-select--message-selected': selectedZone === 0}">
                                    <option v-lang.zonaMensajeSeleccion :value="0" class="form-select--message"></option>
                                    <option v-for="zona in zonas" :value="zona.id" :key="zona.id">
                                        {{ zona.title }}
                                    </option>
                                </select>
                                <span class="error" v-if="zonasError.state"> {{zonasError.message}} </span>
                            </div>
                            <div class="form-input-wrapper" v-if="langs.length > 1">
                                <label class="form-label" for="txt_lang" v-lang.language></label>
                                <select v-model='lang' id="txt_lang" v-jump:click.blur="'btn_login'"  class="form-select">
                                    <option v-for="l in langs" v-bind:value="l.key" v-bind:key="l.key">
                                        {{ l.text }}
                                    </option>
                                </select>
                            </div>
                            <div v-if="!isChofer && settings.modulo_descuento_residente_jubilado" class="form-input-wrapper beneficio-section">
                                <h2 class="form-label">{{ translate('beneficioResidenteJubiladoTitulo') }}</h2>
                                <p class="help">{{ translate('beneficioResidenteJubiladoAyuda') }}</p>
                                <template v-if="user.tipo_beneficio">
                                    <p>
                                        <strong>{{ translate('tipoBeneficio') }}:</strong>
                                        {{ user.tipo_beneficio === 'residente' ? translate('residente') : translate('jubilado') }}
                                    </p>
                                    <p>
                                        <strong>{{ translate('estadoBeneficio') }}:</strong>
                                        <span v-if="beneficioStatus === 'aprobado'" class="text-success">{{ translate('beneficioAprobado') }}</span>
                                        <span v-else-if="beneficioStatus === 'rechazado'" class="error">{{ translate('beneficioRechazado') }}</span>
                                        <span v-else class="text-warning">{{ translate('beneficioPendiente') }}</span>
                                    </p>
                                    <p v-if="beneficioStatus === 'pendiente'" class="help">{{ translate('beneficioPendienteValidacionChofer') }}</p>
                                    <p v-if="beneficioStatus === 'rechazado'" class="help">{{ translate('beneficioRechazadoNoResolicitud') }}</p>
                                </template>
                                <div class="form-group" v-if="canRequestBeneficio">
                                    <label class="form-label" for="tipo_beneficio">{{ translate('tipoBeneficio') }}</label>
                                    <select id="tipo_beneficio" v-model="tipoBeneficio" class="form-select">
                                        <option value="">{{ translate('seleccioneTipoBeneficio') }}</option>
                                        <option value="residente">{{ translate('residente') }}</option>
                                        <option value="jubilado">{{ translate('jubilado') }}</option>
                                    </select>
                                </div>
                                <button v-if="canRequestBeneficio" type="button" class="btn btn-secondary" :disabled="loadingBeneficio || !tipoBeneficio" @click="subirDocumentoBeneficio">
                                    <span v-if="!loadingBeneficio">{{ translate('enviarDocumentoBeneficio') }}</span>
                                    <loader v-else :flag="true" :size="20"></loader>
                                </button>
                                <p v-if="beneficioMessage" :class="beneficioMessageError ? 'error' : ''">{{ beneficioMessage }}</p>
                            </div>
                        </div>


                        <div id="driver_profile" v-if="isChofer">
                            <div class="form-input-wrapper form-input-wrapper--range" v-if="settings.modulo_radio_definida == 0">
                                <label class="form-label" for="range_input"><span v-lang.rango>Rango de búsqueda: </span>{{radioRecepcion / 1000  | distanceConverter(settings.medidas_en_millas) | distanceFormatter(settings.medidas_en_millas,'small')}} / {{radioRecepcion / 1000 | distanceConverter(settings.medidas_en_millas) | distanceFormatter(settings.medidas_en_millas,'big')}}</label>
                                <input type="range" id="range_input" :min="radioRange.min" :max="radioRange.max" :step="radioRange.step" v-model="radioRecepcion"/>
                            </div>
                            <div class="form-input-wrapper" v-if="settings.modulo_chofer_acepta_pago_electronico">
                                <span for="rad-pago-electronico" class="form-label form-label--radio" v-lang.aceptaPagoElectronico>¿Acepta pago electrónico?</span>
                                <span class="form-radio-option">
                                    <input id="rad-pago-electronico" type="radio" name="acepta_pago_electronico" :checked="aceptaPagoElectronico" v-model="aceptaPagoElectronico" v-bind:value="true">
                                    <label for="rad-pago-electronico">Si</label>
                                </span>
                                <span class="form-radio-option">
                                    <input id="rad-pago-efectivo" type="radio" name="acepta_pago_electronico" :checked="!aceptaPagoElectronico" v-model="aceptaPagoElectronico" v-bind:value="false">
                                    <label for="rad-pago-efectivo">No</label>
                                </span>
                            </div>
                            <div class="form-input-wrapper" v-if="settings.modulo_mascotas">
                                <span for="rad-pago-electronico" class="form-label form-label--radio" v-lang.aceptaMascotas>¿Acepta mascotas?</span>
                                <span class="form-radio-option">
                                    <input id="rad-pago-electronico" type="radio" name="aceptaMascotas" :checked="aceptaMascotas" v-model="aceptaMascotas" v-bind:value="true">
                                    <label for="rad-pago-electronico">Si</label>
                                </span>
                                <span class="form-radio-option">
                                    <input id="rad-pago-efectivo" type="radio" name="aceptaMascotas" :checked="!aceptaMascotas" v-model="aceptaMascotas" v-bind:value="false">
                                    <label for="rad-pago-efectivo">No</label>
                                </span>
                            </div>
                            <div class="form-input-wrapper" v-if="settings.modulo_viaje_afuera">
                                <span for="rad-pago-electronico" class="form-label form-label--radio" v-lang.aceptaViajeAfuera>¿Acepta viajar fuera de la ciudad?</span>
                                <span class="form-radio-option">
                                    <input id="rad-pago-electronico" type="radio" name="aceptaViajeAfuera" :checked="aceptaViajeAfuera" v-model="aceptaViajeAfuera" v-bind:value="true">
                                    <label for="rad-pago-electronico">Si</label>
                                </span>
                                <span class="form-radio-option">
                                    <input id="rad-pago-efectivo" type="radio" name="aceptaViajeAfuera" :checked="!aceptaViajeAfuera" v-model="aceptaViajeAfuera" v-bind:value="false">
                                    <label for="rad-pago-efectivo">No</label>
                                </span>
                            </div>
                        </div>
                        <span class="password-options">
                            <input  v-if="!changePassword" v-jump:click.blur="'profile_btn_update'" type="checkbox" ref="profile_change_password" id="profile_change_password" v-model='changePassword' />
                            <input  v-if="changePassword" v-jump:click.blur="'profile_txt_reg_password'" type="checkbox" ref="profile_change_password" id="profile_change_password" v-model='changePassword' />
                            <h2 v-lang.cambiarContrasenia>Cambiar contraseña</h2>
                        </span>
                        <div v-if="changePassword">
                            <div class="form-input-wrapper">
                                <label class="form-label" for="profile_txt_reg_password" v-lang.registerPassword>Contraseña</label>
                                <div class="password-input-inner">
                                    <input v-jump:focus="'profile_txt_password_confirmation'" class="form-input" ref="profile_txt_reg_password" maxlength="40" :type="showProfilePassword ? 'text' : 'password'" id="profile_txt_reg_password" v-model='password' :class="{'has-error': passwordError.state }"/>
                                    <button type="button" class="password-toggle-btn" @click="showProfilePassword = !showProfilePassword" :aria-label="showProfilePassword ? translate('hidePassword') : translate('showPassword')">
                                        <svg-item v-if="!showProfilePassword" :size="22" :icon="'ojo'" :color="'--text-color'"></svg-item>
                                        <svg-item v-else :size="22" :icon="'ojo-cerrado'" :color="'--text-color'"></svg-item>
                                    </button>
                                </div>
                                <span class="error" v-if="passwordError.state"> {{passwordError.message}} </span>
                            </div>
                            <div class="form-input-wrapper">
                                <label class="form-label" for="profile_txt_password_confirmation" v-lang.repeatPassword>Ingrese nuevamente su contraseña</label>
                                <div class="password-input-inner">
                                    <input v-jump:click.blur="'profile_btn_update'" class="form-input" ref="profile_txt_password_confirmation" maxlength="40" :type="showProfilePasswordConfirm ? 'text' : 'password'" id="profile_txt_password_confirmation" v-model='passwordConfirmation' :class="{'has-error': passwordError.state }" />
                                    <button type="button" class="password-toggle-btn" @click="showProfilePasswordConfirm = !showProfilePasswordConfirm" :aria-label="showProfilePasswordConfirm ? translate('hidePassword') : translate('showPassword')">
                                        <svg-item v-if="!showProfilePasswordConfirm" :size="22" :icon="'ojo'" :color="'--text-color'"></svg-item>
                                        <svg-item v-else :size="22" :icon="'ojo-cerrado'" :color="'--text-color'"></svg-item>
                                    </button>
                                </div>
                                <span class="error" v-if="passwordError.state"> {{passwordError.message}} </span>
                            </div>
                        </div>
                        <div v-if="settings.modulos_numeros_seguros">
                            <div class="security-number-header">
                                <span v-lang.numerosSeguridad>Números de seguridad</span>
                                <button @click="addSecurityNumber" v-if="securityNumbers && securityNumbers.length < 2" class="btn btn-default" v-lang.agregar>Agregar</button>
                            </div>
                            <div v-for="(number, index) in securityNumbers" :key="index">
                                <div class="form-group">
                                    <div class="input-group">
                                        <div class="input-group-addon">+54 9</div>
                                        <input type="text" v-model="number.value"  class="form-control" maxlength="10" :class="{'has-error': number.error }" />
                                        <span class="input-group-btn">
                                            <button class="btn btn-default" type="button" @click="removeSecurityNumber(index)" v-lang.quitar>Quitar</button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <small v-lang.numerosSeguridadAyuda>Ingrese hasta 2 números de seguridad que serán notificados por SMS en caso de que usted esté en peligro.</small>
                            </div>
                        </div>
                        <div v-if="!isChofer && settings.modulos_pagos_en_la_app && settings.metodos_pago && settings.metodos_pago.length > 0" class="mt-1_5">
                            <h1 v-lang.metodosPago>Métodos de pagos</h1>
                            <div>
                                <small v-lang.explicacionMetodoPagoDefault>Seleccione el modo por defecto en el cuál desea pagar sus viajes.</small>
                            </div>
                            <div v-for="(method, index) in settings.metodos_pago" :key="index" class="payment-method-radio">
                                <input type="radio" :id="'pm_' + method.id" :value="method.id" v-model="pmDefault" :disabled="method.no_configuration === 0 && user.metodosPagosConfigurados.find(m => m.payment_method_id === method.id) === undefined">
                                <label :for="'pm_' + method.id">{{ vm.translate(method.name) }}</label>
                                <button v-lang.configurar v-if="!method.no_configuration" @click="vm.showConfigPaymentMethod(method)" class="btn-secondary btn-config-payment"></button>
                            </div>
                            <modal v-if="customComponent !== ''">
                                <div slot="body">
                                    <component v-bind:is="customComponent" :ref="'customComponent'" :paymentmethod="customPaymentMethod" :pmconfig="customPaymentMethodConfig" v-on:success="onConfigurationSuccess" :user="user"></component>
                                </div>
                                <div slot="footer">
                                    <button v-lang.close @click="() => {this.customComponent = ''}" class=" btn btn-cancel"></button>
                                </div>
                            </modal>
                        </div>
                        <div class="button-box">
                            <button @click="updateProfile" ref="profile_btn_update" id="profile_btn_update" class="btn btn-primary" :disabled="loading">
                                <span v-if="!loading" v-lang.actualizarPerfil> Actualizar perfil </span>
                                <loader :flag="loading" :color="'var(--primary-button-fg-color)'"> </loader>
                            </button>
                        </div>
                        <hr />
                        <div class="button-box">
                            <button @click="logout" ref="profile_btn_logout" id="profile_btn_logout" class="btn btn-secondary" :disabled="loadingLogout">
                                <span v-if="!loadingLogout" v-lang.logout> Cerrar sesión </span>
                                <loader :flag="loadingLogout"> </loader>
                            </button>
                        </div>
                        <hr />
                        <hr />
                        <hr />
                        <div class="button-box">
                            <button @click="deleteAccount" ref="profile_btn_logout" id="profile_btn_logout" class="btn btn-secondary">
                                <span v-lang.deleteAccount> Cerrar sesión </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Error from '@/services/inputError';
import Forms from '../mixins/forms';
import dialogs from '@/services/dialogs';
import availableLanguages from '@/services/language';
import BraintreePayment from '../components/BraintreePayment';
import PaymentezPayment from '../components/PaymentezPayment';
import { openExternalLink } from '../../cordova/InAppBrowser';
import { apis } from '@/services/api';
import store from '@/store';

let defaultProfilePic = require('@/assets/img/default.jpg');

export default {
    name: 'perfil',
    data () {
        return {
            selectedZone: 0,
            password: '',
            passwordConfirmation: '',
            showProfilePassword: false,
            showProfilePasswordConfirm: false,
            name: '',
            sureName: '',
            telefono: '',
            profilePic: null,
            radioRecepcion: 0,
            loading: false,
            loadingImg: false,
            loadingLogout: false,
            passwordError: new Error(),
            nombreError: new Error(),
            apellidoError: new Error(),
            zonasError: new Error(),
            telefonoError: new Error(),
            changePassword: false,
            aceptaPagoElectronico: false,
            aceptaMascotas: false,
            aceptaViajeAfuera: false,
            lang: 'es',
            langs: [],
            securityNumbers: [
                { value: '' }
            ],
            vm: this,
            pmDefault: 1, // efectivo,
            customComponent: '',
            customPaymentMethod: null,
            showCustomComponent: false,
            customPaymentMethodConfig: null,
            tipoBeneficio: '',
            loadingBeneficio: false,
            beneficioMessage: '',
            beneficioMessageError: false
        };
    },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            zonas: 'company/zonas',
            isChofer: 'auth/isChofer',
            settings: 'company/config'
        }),
        radioRange () {
            let range = {};
            if (this.settings.modulo_limite_radio) {
                range.min = this.settings.modulo_limite_radio.min;
                range.max = this.settings.modulo_limite_radio.max;
                range.step = 10;
            } else {
                if (this.settings.medidas_en_millas) {
                    range.min = 304.8;
                    range.max = 32185.38;
                    range.step = 10;
                } else {
                    range.min = 300;
                    range.max = 30000;
                    range.step = 10;
                }
            }
            return range;
        },
        beneficioStatus () {
            if (!this.user || !this.user.tipo_beneficio) return null;
            if (
                this.user.beneficio_descuento_aprobado === true ||
                this.user.beneficio_descuento_aprobado === 1 ||
                this.user.beneficio_descuento_aprobado === '1'
            ) return 'aprobado';
            if (
                this.user.beneficio_descuento_rechazado === true ||
                this.user.beneficio_estado === 'rechazado' ||
                this.user.estado_beneficio_descuento === 'rechazado'
            ) {
                return 'rechazado';
            }
            return 'pendiente';
        },
        canRequestBeneficio () {
            return this.settings.modulo_descuento_residente_jubilado && this.beneficioStatus === null;
        }
    },
    mounted () {
        this.language = this.$getLang();
        this.customComponent = '';
        if (availableLanguages) {
            for (const key in availableLanguages) {
                if (availableLanguages.hasOwnProperty(key)) {
                    const element = availableLanguages[key];
                    if (key !== 'first') {
                        this.langs.push({
                            text: element.name_language,
                            key: key
                        });
                    }
                }
            }
        }
        this.lang = this.language;
        if (this.user) {
            if (!this.isChofer) {
                this.name = this.user.nombre;
                this.sureName = this.user.apellido;
                this.selectedZone = this.user.zona_id;
                this.telefono = this.user.telefono;
                this.pmDefault = this.user.default_payment_method_id;
                if (this.settings.modulo_foto_pasajero) {
                    this.profilePic = this.user.photo ? this.$profile(this.user.photo) : defaultProfilePic;
                }
            } else {
                this.telefono = this.user.telefono;
                this.radioRecepcion = this.user.chofer.radio_recepcion;
                this.profilePic = this.user.chofer.foto ? this.$profile(this.user.chofer.foto) : defaultProfilePic;
                if (this.settings.modulo_chofer_acepta_pago_electronico) {
                    this.aceptaPagoElectronico = this.user.chofer.acepta_pago_electronico === 1;
                }
                this.aceptaMascotas = this.user.chofer.acepta_mascotas === 1;
                this.aceptaViajeAfuera = this.user.chofer.acepta_viaje_afuera === 1;
            }
            try {
                if (this.user.security_numbers) {
                    this.securityNumbers = JSON.parse(this.user.security_numbers);
                }
            } catch (ex) {
            }
            if (!this.isChofer && this.user.tipo_beneficio && this.beneficioStatus !== 'rechazado') {
                this.tipoBeneficio = this.user.tipo_beneficio;
            }
        }
        if (this.settings.modulo_radio_definida) {
            this.radioRecepcion = this.settings.modulo_radio_definida;
        }
        this.fetchFreshProfile();
    },
    activated () {
        this.fetchFreshProfile();
    },
    methods: {
        ...mapActions({
            update: 'auth/update',
            logoff: 'auth/logout',
            updatePhoto: 'auth/updatePhoto',
            refreshUser: 'auth/refreshUser'
        }),
        applyUserData () {
            if (!this.user) return;
            if (!this.isChofer) {
                this.name = this.user.nombre;
                this.sureName = this.user.apellido;
                this.selectedZone = this.user.zona_id;
                this.telefono = this.user.telefono;
                this.pmDefault = this.user.default_payment_method_id;
                if (this.settings.modulo_foto_pasajero) {
                    this.profilePic = this.user.photo ? this.$profile(this.user.photo) : defaultProfilePic;
                }
            } else {
                this.telefono = this.user.telefono;
                this.radioRecepcion = this.user.chofer.radio_recepcion;
                this.profilePic = this.user.chofer.foto ? this.$profile(this.user.chofer.foto) : defaultProfilePic;
                if (this.settings.modulo_chofer_acepta_pago_electronico) {
                    this.aceptaPagoElectronico = this.user.chofer.acepta_pago_electronico === 1;
                }
                this.aceptaMascotas = this.user.chofer.acepta_mascotas === 1;
                this.aceptaViajeAfuera = this.user.chofer.acepta_viaje_afuera === 1;
            }
            try {
                if (this.user.security_numbers) {
                    this.securityNumbers = JSON.parse(this.user.security_numbers);
                }
            } catch (ex) {}
            if (!this.isChofer && this.user.tipo_beneficio && this.beneficioStatus !== 'rechazado') {
                this.tipoBeneficio = this.user.tipo_beneficio;
            }
        },
        fetchFreshProfile () {
            this.refreshUser().then(() => {
                this.applyUserData();
            }).catch(() => {});
        },
        addSecurityNumber () {
            if (!this.securityNumbers) {
                this.securityNumbers = [
                    { value: '' }
                ];
            }
            if (this.securityNumbers.length < 2) {
                this.securityNumbers.push({ value: '' });
            }
        },
        removeSecurityNumber (index) {
            if (this.securityNumbers && this.securityNumbers.length) {
                this.securityNumbers.splice(index, 1);
            }
        },
        validate () {
            let globalError = false;
            if (this.isChofer) {
                if (this.telefono.length < 1) {
                    this.telefonoError.state = true;
                    this.telefonoError.message = this.translate('forgetPhone');
                    globalError = true;
                }
            } else {
                if (this.name.length < 1) {
                    this.nombreError.state = true;
                    this.nombreError.message = this.translate('forgetName');
                    globalError = true;
                }
                if (this.sureName.length < 1) {
                    this.apellidoError.state = true;
                    this.apellidoError.message = this.translate('forgetSureName');
                    globalError = true;
                }
                if (this.zonas.length > 0 && this.selectedZone === 0) {
                    this.zonasError.state = true;
                    this.zonasError.message = this.translate('notSelectedZone');
                    globalError = true;
                }
                if (this.settings.solicitar_telefono_pasajeros) {
                    if (this.settings.solicitar_telefono_pasajeros.required && this.telefono.length < 1) {
                        this.telefonoError.state = true;
                        this.telefonoError.message = this.translate('forgetTelephone');
                        globalError = true;
                    } else {
                        this.telefonoError.state = false;
                    }
                    if (this.settings.solicitar_telefono_pasajeros.regex && this.telefono.length > 0) {
                        let regex = new RegExp(this.settings.solicitar_telefono_pasajeros.regex);
                        if (!regex.test(this.telefono)) {
                            this.telefonoError.state = true;
                            this.telefonoError.message = this.translate('wrongTelephone');
                            globalError = true;
                        } else {
                            this.telefonoError.state = false;
                        }
                    }
                }
            }
            if (this.changePassword) {
                if (this.password.length < 1) {
                    this.passwordError.state = true;
                    this.passwordError.message = this.translate('forgetPassword');
                    globalError = true;
                } else if (this.password.length < 8) {
                    this.passwordError.state = true;
                    this.passwordError.message = this.translate('minCharsPassword');
                    globalError = true;
                } else if (this.passwordConfirmation < 1) {
                    this.passwordError.state = true;
                    this.passwordError.message = this.translate('forgetPasswordConfirmation');
                    globalError = true;
                } else if (this.password !== this.passwordConfirmation) {
                    this.passwordError.state = true;
                    this.passwordError.message = this.translate('differentPasswords');
                    globalError = true;
                }
            }
            if (this.settings.modulos_numeros_seguros) {
                if (this.securityNumbers && this.securityNumbers.length) {
                    this.securityNumbers.forEach((number) => {
                        if (number && number.value) {
                            if (!/^\d{10}$/.test(number.value)) {
                                this.$set(number, 'error', true);
                                globalError = true;
                            } else {
                                this.$set(number, 'error', false);
                            }
                        }
                    });
                }
            }
            return globalError;
        },
        updateProfile () {
            // TODO: Save default payment method
            if (this.validate()) {
                this.jumpToError();
                return;
            }
            let data = {};
            if (!this.isChofer) {
                data.nombre = this.name;
                data.apellido = this.sureName;
                data.telefono = this.telefono;
                if (this.zonas.length > 1) {
                    data.zona_id = this.zonas.find(z => z.id === this.selectedZone).id;
                }
            } else {
                data.telefono = this.telefono;
                data.radio_recepcion = this.radioRecepcion;
            }
            if (this.changePassword) {
                data.password = this.password;
                data.password_confirmation = this.passwordConfirmation;
            }
            if (this.settings.modulo_chofer_acepta_pago_electronico) {
                data.acepta_pago_electronico = this.aceptaPagoElectronico;
            }
            if (this.settings.modulo_mascotas) {
                data.acepta_mascotas = this.aceptaMascotas;
            }
            if (this.settings.modulo_viaje_afuera) {
                data.acepta_viaje_afuera = this.aceptaViajeAfuera;
            }
            if (this.langs.length > 1) {
                data.lang = this.lang;
            }
            if (this.settings.modulos_numeros_seguros) {
                if (this.securityNumbers && this.securityNumbers.length) {
                    this.securityNumbers.forEach((item) => {
                        delete item.error;
                    });
                    data.security_numbers = JSON.stringify(this.securityNumbers);
                }
            }
            if (this.langs.length > 1) {
                data.lang = this.lang;
            }
            if (this.settings.modulos_pagos_en_la_app && this.settings.metodos_pago && this.settings.metodos_pago.length > 0) {
                data.default_payment_method_id = this.pmDefault;
            }
            this.loading = true;
            this.update(data).then(() => {
                this.loading = false;
                if (this.langs.length > 1) {
                    this.$setLang(this.lang);
                    this.language = this.lang;
                }
                dialogs.message(this.translate('actualizacionExitosa'));
            }).catch(error => {
                dialogs.message(this.translate('actualizacionFallida'), { duration: 10, estado: 'error' });
                console.error(error);
            });
        },
        logout () {
            this.loadingLogout = true;
            this.logoff();
        },
        deleteAccount () {
            // FIXME hardcode
            openExternalLink('https://ourtaxi.myride.com.ar/borrar-cuenta');
        },
        onPhotoChange (data) {
            let fileData = this.$refs.file.$el.files[0];
            let formData = new FormData();
            formData.append('imgProfile', fileData);
            this.loadingImg = true;
            this.updatePhoto(formData).then(photo => {
                dialogs.message(this.translate('actualizacionImagenExitosa'));
                this.profilePic = this.$profile(photo);
                this.loadingImg = false;
            }).catch((err) => {
                this.loadingImg = false;
                dialogs.message(this.translate('actualizacionImagenFallida'), { duration: 10, estado: 'error' });
                console.error(err);
            });
        },
        changePhoto () {
            this.$refs.file.show();
        },
        showConfigPaymentMethod (method) {
            console.log('showConfigPaymentMethod', method);
            if (method && method.options && method.options.vueComponent) {
                this.customComponent = method.options.vueComponent;
                this.customPaymentMethod = method;
                let configuration = null;
                if (this.user && this.user.metodosPagosConfigurados && this.user.metodosPagosConfigurados.length) {
                    configuration = this.user.metodosPagosConfigurados.find(m => m.payment_method_id === method.id);
                }
                this.customPaymentMethodConfig = configuration;
            }
        },
        onConfigurationSuccess (result) {
            console.log('onConfigurationSuccess', result);
            if (this.user && this.user.metodosPagosConfigurados) {
                this.user.metodosPagosConfigurados.push(result);
            }
            this.customComponent = '';
        },
        subirDocumentoBeneficio () {
            if (!this.tipoBeneficio || !this.canRequestBeneficio) return;
            const payload = new FormData();
            payload.append('tipo_beneficio', this.tipoBeneficio);
            this.loadingBeneficio = true;
            this.beneficioMessage = '';
            this.beneficioMessageError = false;
            apis.pasajerosApi.subirDocumentoBeneficio(payload).then((response) => {
                this.loadingBeneficio = false;
                const data = response && response.data !== undefined ? response.data : response;
                const user = data.user || data;
                if (user && user.id) {
                    store.commit('auth/AUTH_SET_USER', user);
                }
                this.beneficioMessage = data.message || this.translate('beneficioSolicitudEnviada');
            }).catch((err) => {
                this.loadingBeneficio = false;
                const msg = (err && err.data && (err.data.message || (err.data.errors && Object.values(err.data.errors).flat()))) || this.translate('errorEnviandoDocumentoBeneficio');
                this.beneficioMessage = Array.isArray(msg) ? msg.join(' ') : msg;
                this.beneficioMessageError = true;
            });
        }
    },
    mixins: [Forms],
    watch: {
        name () { this.nombreError.state = false; },
        sureName () { this.apellidoError.state = false; },
        telefono () { this.telefonoError.state = false; },
        password () { this.passwordError.state = false; },
        passwordConfirmation () { this.passwordError.state = false; },
        changePassword (val) {
            if (!val) {
                this.showProfilePassword = false;
                this.showProfilePasswordConfirm = false;
            }
        }
    },
    components: {
        BraintreePayment,
        PaymentezPayment
    }
};
</script>

<style scoped>
    .container-fluid {
        background: var(--form-background-color);
        min-height: 100%;
    }
    .form-input-wrapper {
        margin-top: 0;
    }
    .form-input-wrapper--range {
        margin-top: 2em;
        margin-bottom: 1.4em;
    }
    .col-container {
        padding: 0 .4em;
    }
    .button-box {
        margin-top: 1.8rem;
    }
    span.error {
        display: block;
        font-size: 12px;
        margin-top: -5px;
        color: red;
        font-weight: bold;
    }
   .form {
        padding: 1.4em;
        margin: 0 -16px;
        background-color: white;
        box-shadow: 0px 1px 5px 3px rgba(0, 0, 0, .1);
    }
    .button-box input[type="checkbox"] {
        display: inline-block;
        vertical-align: top;
    }
    .button-box label {
        display: inline-block;
        width: calc(100% - 20px);
    }
    p {
        margin-top: 0;
    }
    .profile_image-edit {
        position: absolute;
        background: transparent;
        outline: none;
        border: 0;
        bottom: 0;
        right: 0;
    }
    .profile-pic {
        max-width: 244px;
        max-height: 244px;
        position: relative;
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 100%;
        width: 50vw;
        height: 50vw;
        margin: 0 auto;
        cursor: pointer;
    }
    .loading {
        opacity: .3;
    }
    .password-options {
        margin-top: .5em;
    }
    .input-group-btn .btn {
        display: inline-block;
        margin-bottom: 0;
        font-weight: normal;
        text-align: center;
        vertical-align: middle;
        cursor: pointer;
        white-space: nowrap;
        padding: 6px 12px;
        font-size: 14px;
        line-height: 1.42857143;
        border-radius: 4px;
        margin-left: -3px;
        width: auto;
        margin-top: 0;
        box-shadow: none;
        border: 1px solid #ccc;
        z-index: 0;
    }
    .security-number-header {
        margin-top: 2.5em;
        margin-bottom: 1.25em;
        font-weight: bold;
    }
    .security-number-header .btn {
        width: auto;
        display: inline-block;
        vertical-align: middle;
        margin-left: 1em;
        margin-top: 0;
    }
    .input-group .has-error {
        border-color: red;
    }
    .help {
        margin-top: -.4em;
        margin-bottom: 1.2em;
        display: block;
    }
    .payment-method-radio {
        margin: 1em 0 1em .5em;
    }
    .payment-method-radio input {
        margin-right: .3em;
    }
    .payment-method-radio label {
        vertical-align: -1px;
    }
    .payment-method-radio label {
        vertical-align: middle;
    }
    .btn-config-payment {
        padding: .8em;
        min-height: 36px;
        vertical-align: middle;
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/views/Profile.vue